export class RaceDirector {
  constructor(checkpoints) {
    this.checkpoints = checkpoints;
    this.cpCount = checkpoints.length;

    this.activeCpIndex = 0;
    this.currentLap = 1;
    this.totalLaps = 3;
    this.lapStartTime = 0;
    this.lapTime = 0;
    this.bestLapTime = null;
    this.lastLapTime = null;
    this.raceFinished = false;
    this.wrongWay = false;
    this.wrongWayTimer = 0;

    this.triggerRadius = 15.5; // Trigger distance in meters
  }

  start() {
    this.activeCpIndex = 0;
    this.currentLap = 1;
    this.lapStartTime = performance.now();
    this.lapTime = 0;
    this.raceFinished = false;
    this.wrongWay = false;
  }

  update(dt, jeep, onNotification) {
    if (this.raceFinished) return;

    this.lapTime += dt;

    const currentCp = this.checkpoints[this.activeCpIndex];
    const dx = jeep.pos.x - currentCp.x;
    const dz = jeep.pos.z - currentCp.z;
    const distToCp = Math.hypot(dx, dz);

    // 1. Checkpoint pass trigger
    if (distToCp < this.triggerRadius) {
      if (this.activeCpIndex === 0 && this.lapTime > 6.0) {
        // Completed lap!
        this.lastLapTime = this.lapTime;
        if (this.bestLapTime === null || this.lapTime < this.bestLapTime) {
          this.bestLapTime = this.lapTime;
          onNotification?.(`НОВЫЙ РЕКОРД КРУГА!`, this.formatTime(this.bestLapTime));
        } else {
          onNotification?.(`КРУГ ЗАВЕРШЕН!`, this.formatTime(this.lastLapTime));
        }

        if (this.currentLap >= this.totalLaps) {
          this.raceFinished = true;
          onNotification?.(`ФИНИШ ГОНКИ!`, `ЛУЧШИЙ КРУГ: ${this.formatTime(this.bestLapTime)}`);
        } else {
          this.currentLap++;
          this.lapTime = 0;
        }
      }

      this.activeCpIndex = (this.activeCpIndex + 1) % this.cpCount;
    }

    // 2. Wrong-way detection
    const nextCp = this.checkpoints[this.activeCpIndex];
    const toNextX = nextCp.x - jeep.pos.x;
    const toNextZ = nextCp.z - jeep.pos.z;
    const len = Math.hypot(toNextX, toNextZ) || 1;
    const fwd = jeep.forwardVec();
    const dot = (fwd.x * toNextX + fwd.z * toNextZ) / len;

    if (dot < -0.32 && jeep.speed > 5.0) {
      this.wrongWayTimer += dt;
      if (this.wrongWayTimer > 0.6) {
        this.wrongWay = true;
      }
    } else {
      this.wrongWayTimer = 0;
      this.wrongWay = false;
    }
  }

  respawnPose() {
    // Return last passed checkpoint
    const lastIdx = (this.activeCpIndex - 1 + this.cpCount) % this.cpCount;
    const cp = this.checkpoints[lastIdx];
    return {
      x: cp.x,
      z: cp.z,
      y: cp.groundHeight + 0.8,
      yaw: cp.yaw
    };
  }

  formatTime(seconds) {
    if (seconds === null || !Number.isFinite(seconds)) return '--:--.-';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    const d = Math.floor((seconds % 1) * 10);
    const mm = m < 10 ? `0${m}` : `${m}`;
    const ss = s < 10 ? `0${s}` : `${s}`;
    return `${mm}:${ss}.${d}`;
  }
}
